'use client';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useAccountLink } from '../../shared/useAccountLink';

export const AccountLink = () => {
  const { href, label } = useAccountLink();
  return (
    <SlotEquivalentLinksItem href={href}>
      <span className="icon-emp-user size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
